import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function Why({ title, description, type, conclusion }) {
  const [_] = useTranslation("global");
  const { lang } = useParams();
  const whyImg =
    "https://ecombo.sgp1.cdn.digitaloceanspaces.com/assets/why.png";

  const pointsArray = [
    {
      index: 1,
      key: "item1",
      delay: "100",
    },
    {
      index: 2,
      key: "item2",
      delay: "150",
    },
    {
      index: 3,
      key: "item3",
      delay: "200",
    },
    {
      index: 4,
      key: "item4",
      delay: "250",
    },
    {
      index: 5,
      key: "item5",
      delay: "300",
    },
    {
      index: 6,
      key: "item6",
      delay: "350",
    },
  ];
  return (
    <section
      dir={lang === "en" ? "ltr" : "rtl"}
      className="py-3"
      id="why"
      data-aos="fade-up"
    >
      <Container>
        {" "}
        <div
          className="text-center mb-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h2 className="ecombo-primary fw-bold">{title}</h2>
          <p className="mt-3 mx-auto" style={{ maxWidth: "800px" }}>
            {description}
          </p>
        </div>
      </Container>

      <Container className="bg-warning-subtle p-3 rounded">
        <Row className="align-items-center py-2">
          <Col md={6} data-aos="fade-right" data-aos-delay="300">
            <div>
              <ul className="list-unstyled mb-2">
                {pointsArray.map((item) => (
                  <li
                    key={item.key}
                    className="mb-2 d-flex align-items-center why-point"
                    data-aos="fade-up"
                    data-aos-delay={item.delay}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center rounded-circle  ecombo-primary text-white ms-2 shadow-sm"
                      style={{
                        width: 28,
                        height: 28,
                        fontSize: 15,
                        fontWeight: 600,
                      }}
                    >
                      {item.index}
                    </span>
                    <span style={{ fontSize: "1rem", lineHeight: 1.4 }}>
                      {_(`${type}.why.points.${item.key}`)}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="fs-6 mt-3 text-muted mb-0">{conclusion}</p>
            </div>
          </Col>

          <Col
            md={6}
            className="text-center"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <img
              src={whyImg}
              alt={_("static_home.why.imageAlt")}
              className="img-fluid rounded"
              data-aos="zoom-in"
              data-aos-delay="400"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
